// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    {
      "sub": "电力系统基础（俄）",
      "tec": "谢冬梅",
      "week": "1-7周",
      "add": "208国教"
    },
    {
      "sub": "电力系统暂态分析（俄）",
      "tec": "谢冬梅",
      "week": "8-10,14,16-18周",
      "add": "212国教"
    },
    [
      {
        "sub": "毛泽东思想和中国特色社会主义理论体系概论",
        "tec": "张洪涛",
        "week": "1-8周",
        "add": "教学楼A座118电力"
      },
      {
        "sub": "国家安全教育",
        "tec": "张洪涛",
        "week": "9-10,14,16周",
        "add": "教学楼A座118电力"
      }
    ],
    {
      "sub": "工程伦理",
      "tec": "李震金钰",
      "week": "1-8周",
      "add": "教学楼C座214教务"
    },
    0
  ],
  "2": [
    [
      {
        "sub": "电力系统基础（俄）",
        "tec": "谢冬梅",
        "week": "1-7周",
        "add": "212国教"
      },
      {
        "sub": "208国教",
        "tec": "谢冬梅",
        "week": "8-10,14,16-18周",
        "add": "212国教"
      }
    ],
    {
      "sub": "电力电子技术（俄）",
      "tec": "王艳",
      "week": "1-10,14,16-18周",
      "add": "212国教"
    },
    0,
    0,
    0
  ],
  "3": [
    {
      "sub": "自动控制原理（俄）",
      "tec": "于宏涛",
      "week": "1-10周",
      "add": "208国教"
    },
    0,
    0,
    0,
    0
  ],
  "4": [
    {
      "sub": "电力电子技术（俄）",
      "tec": "王艳",
      "week": "1-10,14,16-18周",
      "add": "212国教"
    },
    [
      {
        "sub": "电力系统基础（俄）",
        "tec": "谢冬梅",
        "week": "1-7周",
        "add": "212国教"
      },
      {
        "sub": "208国教",
        "tec": "谢冬梅",
        "week": "8-10,14,16-18周",
        "add": "212国教"
      }
    ],
    0,
    [
      {
        "sub": "毛泽东思想和中国特色社会主义理论体系概论",
        "tec": "张洪涛",
        "week": "1-8周",
        "add": "教学楼C座113教务"
      },
      {
        "sub": "国家安全教育",
        "tec": "张洪涛",
        "week": "9-10,14,16周",
        "add": "教学楼C座113教务"
      }
    ],
    0
  ],
  "5": [
    [
      {
        "sub": "电力系统基础（俄）",
        "tec": "谢冬梅",
        "week": "2,4,6周",
        "add": "212国教"
      },
      {
        "sub": "212国教",
        "tec": "谢冬梅",
        "week": "8,10,16周",
        "add": "212国教"
      }
    ],
    {
      "sub": "自动控制原理（俄）",
      "tec": "于宏涛",
      "week": "1-10周",
      "add": "212国教"
    },
    {
      "sub": "就业创业指导",
      "tec": "孙笑雨",
      "week": "1-8周",
      "add": "教学楼C座214教务"
    },
    0,
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
